import { App } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { SpinnerLoader } from './libraries';
import { ConfigAntdProvider, ErrorProvider, MessageProvider, RouteProvider } from './providers';
import { persistor, store } from './stores';
import './styles/custom.scss';

// Extend Day.js with the plugins
dayjs.extend(relativeTime);

function AppClient() {
  return (
    <Provider store={store}>
      <PersistGate loading={<SpinnerLoader bg={false} />} persistor={persistor}>
        <ConfigAntdProvider>
          <App>
            <MessageProvider>
              <ErrorProvider>
                <RouteProvider />
              </ErrorProvider>
            </MessageProvider>
          </App>
        </ConfigAntdProvider>
      </PersistGate>
    </Provider>
  );
}

export default AppClient;
